<template>
    <div class="dashboard wrap">
        <div class="back-link">
            <router-link :to="{name: 'Dashboard'}">
                <rir-icon icon="arrow-left"></rir-icon> Назад к сводке
            </router-link>
        </div>

        <h1>
            Оперативная сводка по обстановке <br>
            на территории МО г. Южно-Сахалинск
        </h1>
        <br><br>
        <h2>{{kpi.name}}</h2>

        <div class="line-margin">
            <div class="light-button" @click="addChilrendKpi()"><span class="icon icon-plus"></span> Добавить происшествие</div>
        </div>

        <div class="line-margin" v-if="showAddForm">
            <EventEditForm
                    :kpi.sync="kpiAdd"
                    :creating="true"
                    @onSave="loadKpi(); showAddForm = false;"
                    @onCancel="showAddForm = false;"
            ></EventEditForm>
        </div>
        <div class="line-margin">
            <EventEditForm
                    v-for="(kpi, index) in childrenKpi" :key="index"
                    @onDelete="deleteKpi(index)"
                    :kpi.sync="kpi"></EventEditForm>
        </div>
    </div>
</template>

<script>
    import {KpiApi} from '@/api/KpiApi';
    import Kpi from "@/models/Kpi";
    import EventEditForm from "@/components/EventEditForm";

    export default {
        name: 'EventCardEdit',
        components: {
            EventEditForm
        },
        props: {
            uuid: {
                type: String,
                default: () => ''
            }
        },
        data () {
            return {
                kpi: new Kpi(),
                childrenKpi: [],
                showAddForm: false,
                kpiAdd: new Kpi(),
            }
        },
        computed: {
            canAddChild() {
                return this.kpi.maxChildrenCount > this.childrenKpi.length;
            }
        },
        mounted() {
            this.loadKpi();
        },
        methods: {
            async loadKpi() {
                this.kpi = await KpiApi.getByUuid(this.uuid);
                let childrenKpi = await KpiApi.getList({
                    parentId: this.kpi.id,
                    page: 0,
                    size: this.kpi.maxChildrenCount || 1
                });
                this.childrenKpi = childrenKpi.content.map(el => {
                    return new Kpi(el);
                });
            },
            deleteKpi(index) {
                this.childrenKpi.splice(index, 1);
            },
            addChilrendKpi() {
                this.kpiAdd = new Kpi(this.childrenKpi[this.childrenKpi.length - 1]);
                this.showAddForm = true;
            }
        }
    }
</script>

<style scoped>

</style>
